import { z } from 'zod';

import { PricingZod } from 'types/zod/pricing';

export const AdvisorInviteCodeZod = z.object({
    inviteCode: z.string(),
    pricing: PricingZod,
});

export type AdvisorInviteCode = z.infer<typeof AdvisorInviteCodeZod>;
